import { cn } from '@/lib/utils';
import type { SlotProps } from 'input-otp';

export function DigitSlot(props: SlotProps) {
	return (
		<div
			className={cn(
				'relative w-10 h-14 text-3xl',
				'flex items-center justify-center',
				// 'transition-all duration-300',
				'border border-border rounded-md',
				'group-hover:border-accent-foreground/30 group-focus-within:border-accent-foreground/20',
				'outline outline-0 border-accent-foreground/20',
				{ 'outline-2 outline-primary': props.isActive },
			)}>
			{props.char !== null && <div>{props.char}</div>}
			{props.hasFakeCaret && (
				<div className="absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink">
					<div className="w-px h-8 bg-foreground" />
				</div>
			)}
		</div>
	);
}
